import Login from './Login';
import { Stack } from '@fluentui/react';
import { BrowserRouter as Router, Switch, Route }
    from "react-router-dom";
import ACSHelper from './ACSHelper';
import StudentDetails from '../views/StudentDetails'
import { App } from '../App';

export const PageLayout: React.FC<{}> = () => {
    return (
        <Router>
            <Switch>
                {/* <Route path='/'><Login /></Route>
                <Route exact component={ACSHelper} /> */}
                <Route exact path="/" component={Login} />
                <Route exact path="/ACSHelper" component={ACSHelper} />
                <Route exact path="/StudentDetails" component={StudentDetails} />
            </Switch>
        </Router>
    );
}